import React from "react";
import { Callout } from "@sscs/ui";

type RemovalStatusProps = {
  daysUntilDeletion: number | undefined;
  prefixRemovedToday?: string;
  prefixRemovedInDays?: string;
};

const RemovalStatus = ({
  daysUntilDeletion,
  prefixRemovedToday = "Removing",
  prefixRemovedInDays = "Removing in:",
}: RemovalStatusProps): React.JSX.Element | null => {
  if (daysUntilDeletion === undefined) return null;

  const removingIn =
    daysUntilDeletion === 0
      ? `${prefixRemovedToday} Today`
      : `${prefixRemovedInDays} ${daysUntilDeletion.toLocaleString()} day${
          daysUntilDeletion > 1 ? "s" : ""
        }`;

  if (daysUntilDeletion <= 7)
    return <Callout type="error" variant="inline" title={removingIn} />;

  return <span>{removingIn}</span>;
};

export default RemovalStatus;
